<template>
  <div>
    <div class="userTop">
      <div class="userInfo">客户基本信息</div>
      <div class="hea">
        <div style="display:flex;flex-wrap:wrap;width:1241px;">
          <div class="hea_item">姓名：{{userinfo.ctmName}}</div>
          <div class="hea_item">性别：{{userinfo.ctmSex}}</div>
          <div class="hea_item">卡号：{{userinfo.ctmCode}}</div>
          <div class="hea_item">信息来源：{{userinfo.sceName}}</div>
          <!-- <div class="hea_item">病历号:{{userinfo.caseCode}}</div> -->
          <div class="hea_item">手机号：{{userinfo.ctmMobile?userinfo.ctmMobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2"):''}}</div>
          <div class="hea_item">客服：{{userinfo.ctmEmpName}}</div>
          <div class="hea_item">最近上门日期：{{userinfo.ctmCrndate}}</div>
          <div class="hea_item">生日：{{userinfo.ctmCallrvdate}}</div>
          <!-- <div class="hea_item">创建人:{{userinfo.createBy}}</div> -->
          <div class="hea_item">最近消费日期：{{userinfo.ctmPurchaseDate}}</div>
          <div class="hea_item">年龄：{{userinfo.ctmAge}}</div>
          <div class="hea_item">注册时间：{{userinfo.createTime}}</div>
          <div class="hea_item" :span="8">标签：</div>
          <div class="hea_item" :span="8">地区：{{userinfo.ctmCardno}}</div>
          <div class="hea_item" :span="8">首次消费院区：{{userinfo.earName}}</div>
          <div class="hea_item" :span="8">初诊日期：{{userinfo.ctmDate}}</div>
          <!-- <div class="hea_item" :span="8">更多信息>></div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['userinfo',],
  data() {
    return {
    }
  }
}
</script>
<style scoped>
.hea {
  display: flex;
  align-items: center;
}
.hea_item {
  width: 25%;
  margin-bottom: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
}
.userTop {
  padding: 0 30px;
  box-sizing: border-box;
  box-shadow: 0px 2px 7px 2px #ebeef5;
}
.userInfo {
  padding: 10px 0;
  box-sizing: 500;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #626365;
}
</style>

